import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON017_Request,
  IAPI_CON017_Response,
} from "../../../type/apiType";
import {
  IAPI_CON019_Request,
  IAPI_CON019_Response,
} from "../../../type/apiType";

// 直近3ヶ月の退職者一覧参照API
const httpIAPI_CON017 = async (
  param: IAPI_CON017_Request
): Promise<IAPI_CON017_Response> => {
  let res = await http.post(ApiUrl.API_CON017, {
    ...param,
  });

  return res.data;
};

// 直近3ヶ月の退職者一覧更新参照API
const httpIAPI_CON019 = async (
  param: IAPI_CON019_Request
): Promise<IAPI_CON019_Response> => {
  let res = await http.post(ApiUrl.API_CON019, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_CON017, httpIAPI_CON019 };
